import Vue from 'vue'

Vue.filter('timeFormat', function (value) {
  if (value) {
    let date = new Date(value);
    let Y = date.getFullYear() + '-';
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
    let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return Y + M + D + h + m + s;
  } else {
    return ''
  }

})


Vue.filter('timeFormat2', function (value) {
  if (value) {
    let date = new Date(value);
    let Y = date.getFullYear() + '年';
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
    let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + '日';
    return Y + M + D;
  } else {
    return ''
  }

})


Vue.filter('typeFormat', function (value) {
  if (value == 1) {
    return '销售'
  } else if (value == 2) {
    return '生产'
  }
})